import {MeetingCommentFile} from './MeetingCommentFile'
import {InputError} from '../components/AdminMeetingCommentInputForm'
import {SubmitCommentAndFilesTemplateForAdmin} from './SubmitCommentAndFilesTemplateForAdmin'
import {MeetingRepositoryForAdmin} from '../MeetingRepositoryForAdmin'
import {AsyncCallFunctionType, AsyncFunction} from '../../shared/hoc/withAsyncCommunication'
import EventEmitterExAdmin from '../../shared/pageBaseComponents/EventEmitterExAdmin'
import UpdateMeetingComment from './UpdateMeetingComment'
import {FileDataForValidate} from './FileDataForValidate'

interface SendData {
    condominiumCd: string
    meetingId: number
    replySourceId: number
    commentId: number
    updateMeetingCommentReply: UpdateMeetingComment
}

export class SubmitUpdateCommentReplyProcedureForAdmin extends SubmitCommentAndFilesTemplateForAdmin<SendData> {
    meetingRepoForAdmin: MeetingRepositoryForAdmin

    constructor(
        registerCommentError: (inputError: InputError) => void,
        meetingRepositoryForAdmin: MeetingRepositoryForAdmin,
        asyncCallFunction: AsyncCallFunctionType,
        eventEmitter: EventEmitterExAdmin,
    ) {
        super(registerCommentError, asyncCallFunction, eventEmitter)
        this.meetingRepoForAdmin = meetingRepositoryForAdmin
    }

    registerCommentFunction(sendData: SendData): AsyncFunction<any, number> {
        return async () => {
            await this.meetingRepoForAdmin.updateCommentReply(
                sendData.condominiumCd,
                sendData.meetingId,
                sendData.replySourceId,
                sendData.commentId,
                sendData.updateMeetingCommentReply,
            )
            return sendData.commentId
        }
    }

    validateFileFunction(fileDataForValidate: FileDataForValidate): AsyncFunction<any, void> {
        return () => this.meetingRepoForAdmin.validateParallelFileUpload(fileDataForValidate)
    }

    async registerFile(sendData: SendData, commentId: number, commentFile: MeetingCommentFile): Promise<void> {
        // NatAsyncCallFunctionによる標準の通信エラー処理を行わない
        // 原因はなんであれファイルを再登録する必要があることをユーザーに伝える必要があるため、全ての例外を捕捉する
        await this.meetingRepoForAdmin.registerCommentReplyFile(
            sendData.condominiumCd,
            sendData.meetingId,
            sendData.replySourceId,
            commentId,
            commentFile,
        )
    }

    async submit(
        condominiumCd: string,
        meetingId: number,
        replySourceId: number,
        commentId: number,
        updateMeetingComment: UpdateMeetingComment,
        commentFileList: MeetingCommentFile[],
    ): Promise<boolean> {
        return await this.process(
            {
                condominiumCd: condominiumCd,
                meetingId: meetingId,
                replySourceId: replySourceId,
                commentId: commentId,
                updateMeetingCommentReply: updateMeetingComment,
            },
            commentFileList,
        )
    }
}
